import React from 'react';
import AeroIcon from './AeroIcon';

/**
 * AeroPageHeader: the v3 page header bar (research/v3 .mhead): a 52px bar
 * with a hairline under it, the page name (or a crumb trail, "Tests › Pocket ›
 * Sessions › Maya" with chevrons, as in the product demo) on the left and
 * the page's actions on the right. Flat v3 styles: .aero-ph* in
 * aero-ut-theme.css (render inside .ut-theme).
 *
 * Props:
 *   crumbs   [{ label, onClick }] ending with the current page; the last one is
 *            the page name (bold). A single string is the page name alone.
 *   actions  nodes for the right side (buttons)
 *   center   optional nodes centred in the bar (session review's Watch / Read)
 */
export default function AeroPageHeader({ crumbs, actions = null, center = null, className = '' }) {
  const list = typeof crumbs === 'string' ? [{ label: crumbs }] : crumbs || [];
  return (
    <header className={`aero-ph ${className}`.trim()}>
      <nav className="aero-ph-crumb" aria-label="Breadcrumb">
        {list.map((c, i) => {
          const last = i === list.length - 1;
          return (
            <React.Fragment key={`${c.label}-${i}`}>
              {i > 0 && <AeroIcon name="right" className="aero-ph-sep" />}
              {last ? (
                <h1 className="aero-ph-title">{c.label}</h1>
              ) : (
                <button type="button" className="aero-ph-link" onClick={c.onClick}>{c.label}</button>
              )}
            </React.Fragment>
          );
        })}
      </nav>
      {center && <div className="aero-ph-center">{center}</div>}
      {actions && <div className="aero-ph-actions">{actions}</div>}
    </header>
  );
}
